var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 40,
    viewBox: "0 0 25 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 39,
    rx: 4.5,
    fill: "white",
    stroke: "#CEDDE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4688 16.4844L19.5156 20.5312C19.6523 20.668 19.6523 20.8594 19.5156 20.9961L15.4688 25.043C15.332 25.1797 15.1133 25.1797 15.0039 25.043L14.457 24.4961C14.3203 24.3867 14.3203 24.168 14.457 24.0312L17.1094 21.4883H10.3281C10.1367 21.4883 10 21.3242 10 21.1602V20.3945C10 20.2031 10.1367 20.0664 10.3281 20.0664H17.1094L14.457 17.4961C14.3203 17.3594 14.3203 17.1406 14.457 17.0312L15.0039 16.4844C15.1133 16.3477 15.332 16.3477 15.4688 16.4844ZM8.79688 25.6719C8.79688 25.8633 8.63281 26 8.46875 26H7.70312C7.51172 26 7.375 25.8633 7.375 25.6719V15.8281C7.375 15.6641 7.51172 15.5 7.70312 15.5H8.46875C8.63281 15.5 8.79688 15.6641 8.79688 15.8281V25.6719Z",
    fill: "#005587"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.b5fd1510.svg";
export { ForwardRef as ReactComponent };